// import axios from 'axios'

// 基础服务工具类
class Base {
  static get(url, params, config) {
    return window.$httpUtil.get(url, params, config)
  }

  static post(url, data, config) {
    return window.$httpUtil.post(url, data, config)
  }
}

export default Base
